import { styled } from '@mui/material/styles';
import { Typography } from '../../atoms/Typography';

export const Title = styled(Typography)`
  width: 100%;
  width: 150px;
`;